import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LiftWarningLevel } from 'src/app/core/graphql/generated/gen-types';
import { liftLevelClass, liftLevelIcon, liftLevelLabel } from './lift-warning.util';

/**
 * Four-zone spare-lift indicator (111-balloon-lift-warning), judged server-side per flight
 * against the balloon's own thresholds; blue means the worst-case landing mass (takeoff minus
 * all burnable gas) sits below the balloon's MLM (minimum landing mass).
 *
 * Colour is never the only channel (flyability convention): every level carries its own glyph
 * and a tooltip label. Blue is a warning, deliberately styled unlike the green success state.
 * A null level means the lift inputs are incomplete — the host surface keeps its own
 * mismatch/error rendering, this badge falls back to the old binary block icon.
 */
@Component({
	selector: 'app-lift-warning-badge',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule],
	template: `
		<mat-icon
			class="lift-warning-badge"
			[ngClass]="levelClass(level)"
			[matTooltip]="levelLabel(level) | translate"
			[attr.aria-label]="levelLabel(level) | translate"
			>{{ levelIcon(level) }}</mat-icon
		>
	`,
	styleUrls: ['./lift-warning-badge.component.scss'],
})
export class LiftWarningBadgeComponent {
	@Input() level: LiftWarningLevel | null = null;

	levelClass = liftLevelClass;
	levelIcon = liftLevelIcon;
	levelLabel = liftLevelLabel;
}
